import { render, staticRenderFns } from "./allInfo.vue?vue&type=template&id=0ba258c4&"
import script from "./allInfo.vue?vue&type=script&lang=js&"
export * from "./allInfo.vue?vue&type=script&lang=js&"
import style0 from "./allInfo.vue?vue&type=style&index=0&lang=less&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports